module.exports = __webpack_public_path__ + "static/img/package_all.ff30061.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/package_all.jpg
// module id = yPJY
// module chunks = 1